module.exports = __webpack_public_path__ + "static/img/20015 (1).47791ce.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20015 (1).webp
// module id = Z/O8
// module chunks = 14